import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel } from '@mui/material';
import { Controller } from 'react-hook-form';

export default function ControlledCheckbox({ control, name = 'stayLoggedIn', label = 'Angemeldet bleiben' }) {
  return (
    <FormControlLabel
      control={
        <Controller
          name={name}
          control={control}
          render={({ field }) => <Checkbox onChange={(e) => field.onChange(e.target.checked)} checked={field.value} />}
        />
      }
      label={label}
    />
  );
}

ControlledCheckbox.propTypes = {
  control: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
};

// ALTERNATIVE:
// <Controller
// render={({ field }) => <TextField {...field} />}
// name="TextField"
// control={control}
// />
